// Package imports:
import React, { useContext} from 'react';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import ScrollLock from 'react-scrolllock';
// Component imports:
import Button from '../../../ui-elements/Button/Button';
import Icon from '../CustomIcon/CustomIcon';
import NavDropdown from './NavDropdown';
import Logo from '../Logo/Logo';
import {use100vh} from 'react-div-100vh'
// Context imports:
import { UserInfoContext } from '../../../contexts/UserInfoContext';

interface IOwnProps {
    isMobileNavMenuOpen?: boolean
    onMenuExitClick?: () => void
}

const Nav: React.FC<IOwnProps> = ({
    isMobileNavMenuOpen = false,
    onMenuExitClick
}) => {
    const userInfo = useContext(UserInfoContext);
    const isLoggedIn = userInfo?.isAuthenticated ?? false;

    const gagnaleitDropdown = [{
        link: "/Einstaklingar/Hlutafelagathatttaka",
        label: "Aðild / Hlutafélagaþátttaka",
        noLock: true,
    }, {
        link: "/Fasteignir/Leit",
        label: "Fasteignir",
        noLock: true
    }, {
        link: "/Fyrirtaeki/Leit",
        label: "Fyrirtækjaleit",
        noLock: true
    }, {
        link: "/Fasteignir/Kaupsamningar",
        label: "Kaupsamningar",
        noLock: true
    }, {
        link: "/Fasteignir/Leigusamningar",
        label: "Leigusamningar",
        noLock: true
    }, {
        link: "/Okutaeki",
        label: "Ökutækjaskrá"
    }, {
        link: "/Logbirtingar/Leit",
        label: "Lögbirtingar",
        noLock: true
    }, {
        link: "/Einstaklingar/Thjodskra",
        label: "Þjóðskrá",
        noLock: true
    }];
    const height = use100vh();

    return (
        <ScrollLock isActive={isMobileNavMenuOpen}>
            <div style={{height: isMobileNavMenuOpen ? height?.toString() + 'px' : 'unset'}} className='KCL_nav-container' >
                {/* Only visible when in mobile */}
                <div className="nav-container__top">
                    <Logo />

                    <button
                        type="button"
                        onClick={onMenuExitClick}
                    >
                        <span className="nav__icon">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </button>
                </div>
                {/* Always visible */}
                <ul className="nav__main">
                    <NavDropdown
                        triggerLabel="Markaðurinn"
                    >
                        <ul className="nav__sub">
                            <li className="nav__sub-col">
                                <ul>
                                    <li>
                                        <a href="/Markadir/Hlutabref">Hlutabréf</a>
                                    </li>
                                    <li>
                                        <a href="/Markadir/Skuldabref">Skuldabréf</a>
                                    </li>
                                    <li>
                                        <a href="/Markadir/Gjaldeyrismarkadur">Gjaldeyrismarkaður</a>
                                    </li>
                                    <li>
                                        <a href="/Markadir/Gjaldmidlar">Gjaldmiðlar</a>
                                    </li>
                                    <li>
                                        <a href="/Markadir/Visitolur">Vísitölur</a>
                                    </li>
                                    <li>
                                        <a href="/Markadir/Sjodir">Sjóðir</a>
                                    </li>
                                    <li>
                                        <a href="/Markadir/Sereignarsjodir">Séreignarsjóðir</a>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav__sub-col">
                                <ul>
                                    <li>
                                        <a href="/Markadir/Fjarmalahugtok">Fjármálahugtök</a>
                                    </li>
                                    <li>
                                        <a href="/Markadir/Gemmaq">GEMMAQ Kynjakvarði</a>
                                    </li>
                                </ul>
                                <div className="call-to-action-wrapper cta-far">
                                    <Button anchorProps={{ href: "/Dagatal" }}>
                                        <Icon type="calendar" />
                                        <span>Dagatal viðskiptalífsins</span>
                                    </Button>

                                    <Button anchorProps={{ href:"/Frettir" }}>
                                        <Icon type="newspaper" />
                                        <span>Fréttavakt Keldunnar</span>
                                    </Button>
                                </div>
                            </li>
                        </ul>
                    </NavDropdown>
                    <NavDropdown
                        triggerLabel="Gagnaleit"
                    >
                        <ul className="nav__sub">
                            <li className="nav__sub-col">
                                <ul>
                                    {gagnaleitDropdown.map(({link, label, noLock}) => {
                                        let hasLock = (!noLock && !isLoggedIn);
                                        return (
                                            <li key={label}>
                                                <a
                                                    href={link}
                                                    className={cx({'is-disabled': hasLock})}
                                                >
                                                    {label}
                                                    {hasLock && (
                                                        <span className="lock-icon">
                                                            <FontAwesomeIcon icon={faLock} />
                                                        </span>
                                                    )}
                                                    {(label === 'Kaupsamningar' || label === 'Leigusamningar') && (
                                                        <span className="badge">Nýtt</span>
                                                    )}
                                                </a>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </li>
                        </ul>
                    </NavDropdown>
                    <NavDropdown
                        triggerLabel="Keldan"
                    >
                        <ul className="nav__sub">
                            <li className="nav__sub-col">
                                <ul>
                                    <li>
                                        <a href="/Um-Okkur">Um Kelduna</a>
                                    </li>
                                    <li>
                                        <a href="/Verdskra">Áskriftarleiðir</a>
                                    </li>
                                    <li>
                                        <a href="/Verdskra#verdskra">Verðskrá</a>
                                    </li>
                                    <li>
                                        <a href="/Listar">Markhópalistar</a>
                                    </li>
                                    <li>
                                        <a href="/Vefthjonusta">Vefþjónusta (API)</a>
                                    </li>
                                    <li>
                                        <a href="/Areidanleikakannanir">Áreiðanleikakannanir</a>
                                    </li>
                                    <li>
                                        <a href="/Keldan-App">Keldan App</a>
                                    </li>
                                    <li>
                                        <a href="/Vaktarinn">Vaktarinn</a>
                                    </li>
                                    <li>
                                        <a href="/Auglysingar">Auglýsingar</a>
                                    </li>
                                </ul>
                                <div className="call-to-action-wrapper">
                                    <Button anchorProps={{ href: "/Listar/Fyrirmyndarfyrirtaeki" }}>
                                        <Icon type="cup" />
                                        <span>Fyrirmyndarfyrirtæki í rekstri</span>
                                    </Button>
                                </div>
                            </li>
                        </ul>
                    </NavDropdown>
                </ul>
            </div>
        </ScrollLock>
  );
}

export default Nav;
